import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/setting_option_selected.svg'
import _imports_1 from '@/assets/img/setting_option.svg'
import _imports_2 from '@/assets/img/setting_option_active.svg'


const _withScopeId = n => (_pushScopeId("data-v-5d23aed9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "vendor-assess-external-input-questions",
  class: "tw-py-5 tw-px-5 md:tw-py-[55px] md:tw-px-[60px] tw-flex tw-flex-col tw-gap-5 tw-rounded-b-[6px]",
  style: {"background":"var(--UI-rule-50, rgba(239, 240, 241, 0.5))"}
}
const _hoisted_2 = {
  id: "vendor-assess-external-input-questions",
  class: "tw-flex tw-flex-col tw-justify-between tw-w-full tw-gap-5"
}
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-items-center tw-flex-wrap tw-gap-5" }
const _hoisted_4 = { id: "vendor-assess-external-input-questions-search-box" }
const _hoisted_5 = {
  id: "vendor-assess-external-input-notes",
  class: "tw-flex tw-items-center tw-flex-wrap xl:tw-gap-[20px] tw-gap-2"
}
const _hoisted_6 = { class: "tw-cursor-pointer" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_10 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_11 = {
  key: 0,
  id: "vendor-assessment-question-detail",
  class: "tw-flex tw-flex-col tw-gap-[20px] tw-w-full tw-rounded-[6px]"
}
const _hoisted_12 = { class: "tw-mt-[10px]" }
const _hoisted_13 = { class: "tw-flex tw-mt-[10px] tw-justify-between tw-items-center" }
const _hoisted_14 = { class: "tw-font-Poppins tw-text-[13px] tw-font-[500] tw-text-[#231F20]" }
const _hoisted_15 = ["disabled"]

import { Ref, ref, computed, onMounted, watch } from "vue";
import {
  formatVendorData,
  getComponentUiText,
  searchQuestion,
} from "@/utils/utilities";
import AssessmentCategoryHeader from "@/components/assessment/assessmentCategoryHeader.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import VendorAssessmentQuestionsDetail from "./vendorAssessmentQuestionsDetail.vue";
import VendorAssessmentNote from "./vendorAssessmentNote.vue";
import Button1 from "../common/button1.vue";
import store from "@/store";
import AssessmentDisplayOptions from "../assessment/assessmentDisplayOptions.vue";
import BaseSearchbox from "../common/form/baseSearchbox.vue";
import RightSlideModal from "@/components/common/rightSlideModal.vue";
import {
  COMPLIANCE_TYPE,
  infomationRequiredId,
  localStorageKey,
  MODAL_NAME,
  successStatusCodes,
} from "@/utils/constants";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import {
  deleteChecklistRequestedAttachment,
  IParamsUpdateChecklistRequestedItems,
  putRequestAssessmentEmail,
  updateChecklistRequestedExternalItem,
} from "@/services/vendor";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Vendor } from "@/services/apiRoutes/routes";
import { postRequestAssessmentEmailSubmit } from "@/services/vendor";
import router from "@/router";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import AssessmentQuestionSubCategorySkeleton from "../skeleton/assessmentQuestionSubCategorySkeleton.vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentQuestions',
  setup(__props) {

const selectedQuestions: Ref<any> = ref([]);
const selectedQuestionsChild: Ref<any> = ref([]);
const search = ref("");
const isCogHover: Ref<boolean> = ref(false);
const isShowToolTip: Ref<boolean> = ref(false);
const isCheckToggleOptionSetting: Ref<boolean> = computed(
  () => hideComplete.value || hideReviewed.value || infomationRequired.value,
);
const currentPage = ref(1);
const totalPages = ref(25);
const popover_option: any = ref(null);
const isShowMoreActions = ref(false);
let checklistRequestedNotes = undefined;

const hideComplete: any = ref(
  localStorage.getItem(localStorageKey.isHideCompleteVendorInput) === "true",
);
const hideReviewed: any = ref(
  localStorage.getItem(localStorageKey.isHideCompleteVendorReview) === "true",
);
const isLoadingAPI = ref(false);
const innerTextSubmitBtnRef: Ref = ref(null);
const animationWidth = ref(0);

const isLoadingRequestedInput = computed(
  () => store.state.Vendor.isLoadingRequestedInput,
);

const infomationRequired: any = ref(null);
const listOption = computed(() => [
  {
    title: getComponentUiText(
      "app-component-assessment-vendor-display-options-filter-hide-complete-1",
    ),
    value: hideComplete.value,
    action: hideCompleteAction,
    dataCy: "assessment-display-options-hide-complete",
  },
  {
    title: getComponentUiText(
      "app-component-vendor-assessment-display-options-hide-reviewed-1",
    ),
    value: hideReviewed.value,
    action: hideReviewedAction,
    dataCy: "assessment-display-options-hide-reviewed",
  },
  {
    title: getComponentUiText(
      "app-component-vendor-question-information-required-1",
    ),
    value: infomationRequired.value,
    action: infomationRequiredAction,
    dataCy: "assessment-display-options-information-required",
  },
]);
const isOverlayVisible = ref(false);
const closeRightSliderMenu = () => {
  isOverlayVisible.value = false;
};

const listQuestion: any = computed(() => {
  let dataFilter = dataVendor.value?.checklistRequestedItems ?? [];

  if (hideReviewed.value) {
    dataFilter = dataFilter.filter(
      (item: any) => !checkQuestionIsReviewed(item),
    );
  }

  if (hideComplete.value) {
    dataFilter = dataFilter.filter(
      (item: any) => !checkQuestionIsComplete(item),
    );
  }

  if (infomationRequired.value) {
    dataFilter = dataFilter?.filter(
      (item: any) =>
        (item?.checklistItemNotesOrgExternal &&
          item?.checklistItemComplianceTypeValueOrgId ===
            infomationRequiredId) ||
        item?.checklistItemIsHeading,
    );
  }

  dataFilter = searchQuestion(dataFilter ?? [], search.value) ?? [];

  let dataFormat = formatVendorData(dataFilter);

  if (isCheckToggleOptionSetting.value) {
    dataFormat = dataFormat.filter(
      (item) => item.checklistItemChildren?.length,
    );
  }

  return dataFormat;
});

const dataVendor = computed(
  () => store.state.Vendor?.checklistVendorRequestedExternalInput,
);
const complianceTypeValues = computed(
  () => store.state.Vendor.checklistComplianceTypeValues,
);

const isCheckStatusInprogAndWait = computed(
  () => store.getters["Vendor/isCheckStatusInprogAndWait"],
);

onMounted(() => {
  listenOpenImageModal();
});

watch(
  () => dataVendor.value,
  (newVal) => {
    if (newVal?.checklistRequestedItems && infomationRequired.value === null) {
      infomationRequired.value = newVal?.checklistRequestedItems.some(
        (item: any) => item.checklistItemNotesOrgExternal,
      );
    }
  },
);

const listenOpenImageModal = () => {
  EventEmitter.on(EmitterEvents.OPEN_IMAGE_MODAL, (item: any) => {
    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_VENDOR_ASSESSMENT_ATTACHMENT,
      properties: {
        urlAttachment: item.urlAttachment,
      },
    };

    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  });
};

const childQuestionId = computed(() => {
  const childData = dataVendor.value?.checklistRequestedItems.filter(
    (item: any) =>
      item.checklistItemComplianceTypeId !== "na" &&
      item.checklistItemComplianceTypeId !== null,
  );
  return childData.map((item: any) => item.itemMasterId);
});
const checkQuestionIsComplete = (item: any) => {
  switch (item?.checklistItemComplianceTypeId) {
    case COMPLIANCE_TYPE.ATTACH:
      return item?.checklistItemAttachments?.length;
    case COMPLIANCE_TYPE.YES_NO:
      return item?.checklistItemComplianceTypeValueId !== null;
    case COMPLIANCE_TYPE.TEXT:
      return item?.checklistItemCompensatingControlDescription;
    default:
      return false;
  }
};

const checkQuestionIsReviewed = (item: any) => {
  return (
    item.checklistItemComplianceTypeValueOrgId ||
    item.checklistItemComplianceOverride
  );
};
const openDisplayOption = () => {
  setTimeout(() => {
    popover_option?.value?.$emit("show");
  }, 500);
};

const hideCompleteAction = () => {
  hideComplete.value = !hideComplete.value;
  localStorage.setItem(
    localStorageKey.isHideCompleteVendorInput,
    JSON.stringify(hideComplete.value),
  );
};

const hideReviewedAction = () => {
  hideReviewed.value = !hideReviewed.value;
  localStorage.setItem(
    localStorageKey.isHideReviewedVendorInput,
    JSON.stringify(hideReviewed.value),
  );
};

const infomationRequiredAction = () => {
  infomationRequired.value = !infomationRequired.value;
};

const handleSelectedQuestions = (value: any) => {
  const id = value.item?.itemMasterId;
  const idChildrent =
    value.item?.checklistItemChildren?.map((item: any) => item.itemMasterId) ??
    [];
  if (selectedQuestions.value.includes(id)) {
    selectedQuestions.value = selectedQuestions.value.filter(
      (item: any) => item !== id,
    );
    idChildrent.forEach((item: any) => {
      selectedQuestions.value = selectedQuestions.value.filter(
        (child: any) => child !== item,
      );
    });
  } else {
    selectedQuestions.value = [...selectedQuestions.value, id];
    idChildrent.forEach((item: any) => {
      if (!selectedQuestions.value.includes(item)) {
        selectedQuestions.value = [...selectedQuestions.value, item];
      }
    });
  }
  selectedQuestionsChild.value = selectedQuestions.value.filter((id: number) =>
    childQuestionId.value.includes(id),
  );
};

const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
};

const handleUpdateItems = async () => {
  const checklistRequestedId: number = dataVendor.value?.checklistRequestedId;
  const selectedQuestionsData =
    dataVendor.value?.checklistRequestedItems.filter((item: any) => {
      return (
        selectedQuestions.value.includes(item.itemMasterId) &&
        item.checklistItemComplianceTypeId !== null &&
        item.checklistItemComplianceTypeId !== "na"
      );
    });
  const checklistItemAttachments: [] = selectedQuestionsData.filter(
    (item: any) =>
      item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.ATTACH &&
      item.checklistItemAttachments.length > 0,
  );
  const updatCheckListParams: IParamsUpdateChecklistRequestedItems = {
    checklistRequestedItems: selectedQuestionsData.map((item: any) => {
      if (
        item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.YES_NO ||
        item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.ATTACH
      ) {
        return {
          checklistRequestedItemId: item.checklistItemId,
          complianceTypeValueId: null,
        };
      }
      if (item.checklistItemComplianceTypeId === COMPLIANCE_TYPE.TEXT) {
        return {
          checklistRequestedItemId: item.checklistItemId,
          compensatingControlDescription: "",
        };
      }
    }),
  };
  try {
    const deleteAttachmentPromises = checklistItemAttachments.map(
      (item: any) => {
        const attachmentIds = item.checklistItemAttachments.map(
          (attachment: any) => attachment.attachmentId,
        );
        if (attachmentIds.length) {
          return deleteChecklistRequestedAttachment({
            checklistItemId: item.checklistItemId,
            checklistRequestedId,
            checklistItemAttachmentIds: attachmentIds,
          });
        }
        return Promise.resolve();
      },
    );
    const [updateRes, ...deleteAttachmentResRaw] = await Promise.all([
      updateChecklistRequestedExternalItem(
        checklistRequestedId,
        updatCheckListParams,
      ),
      ...deleteAttachmentPromises,
    ]);
    const deleteAttachmentRes = deleteAttachmentResRaw.filter(
      (res) => res !== undefined,
    );
    if (
      updateRes.status === successStatusCodes.OK ||
      deleteAttachmentRes.some((res) => res.status === successStatusCodes.OK)
    ) {
      await store.dispatch("Vendor/fetchVendorRequestedExternalInput");
      EventEmitter.emit(EmitterEvents.CLOSE_MODAL);
      selectedQuestions.value = [];
      selectedQuestionsChild.value = [];
    }
  } catch (error) {
    showErrorAPI(error, Vendor.putChecklistRequestedExternalItem);
  }
};

const showModalResetAnswers = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-assessment-modal-bulk-reset-answers-header-1",
      ),
      class: "tw-top-[0px]",
      description: getComponentUiText(
        "app-assessment-modal-bulk-reset-answers-description-1",
        false,
        { numberQuestions: selectedQuestionsChild.value.length.toString() },
      ),
      hiddenHelp: false,
      buttonText: getComponentUiText(
        "app-assessment-modal-reset-answers-button-text-1",
      ),
      buttonRed: true,
    },
    events: {
      "update:data": () => {
        handleUpdateItems();
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const handleSubmit = async () => {
  if (isLoadingAPI.value) return;
  isLoadingAPI.value = true;
  if (innerTextSubmitBtnRef.value) {
    animationWidth.value = innerTextSubmitBtnRef.value.getBoundingClientRect()[
      "width"
    ] as number;
  }
  try {
    const checklistRequestedId = dataVendor.value.checklistRequestedId;
    const res = await postRequestAssessmentEmailSubmit(checklistRequestedId);
    if (res.status === successStatusCodes.OK) {
      router.push({
        name: "AssessmentVendorSubmit",
        query: { orgName: dataVendor.value.orgName },
      });
    }
  } catch (error: any) {
    isLoadingAPI.value = false;
    showErrorAPI(error, Vendor.getRequestedAssessment);
  }
};

const handlePutNoteResponse = async (val) => {
  try {
    if (checklistRequestedNotes === undefined) {
      checklistRequestedNotes = dataVendor.value.notesResponse || "";
    }
    if (val === checklistRequestedNotes) return;
    checklistRequestedNotes = val;
    const checklistRequestedId = dataVendor.value.checklistRequestedId;
    const res = await putRequestAssessmentEmail(checklistRequestedId, val);
    if (res.status === successStatusCodes.OK) {
      showSuccessToast(
        getComponentUiText("app-assessments-vendor-questions-note-success-1"),
      );
    }
  } catch (error: any) {
    showErrorAPI(error, Vendor.getRequestedAssessment);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RightSlideModal, {
        "is-show": isOverlayVisible.value,
        onShow: _cache[0] || (_cache[0] = ($event: any) => (isOverlayVisible.value = true)),
        onClose: _cache[1] || (_cache[1] = ($event: any) => (isOverlayVisible.value = false))
      }, null, 8, ["is-show"]),
      _withDirectives(_createElementVNode("div", {
        class: "overlay color",
        onClick: closeRightSliderMenu
      }, null, 512), [
        [_vShow, isOverlayVisible.value]
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AssessmentCategoryHeader, {
          title: 
          _unref(getComponentUiText)(
            'app-assess-recommendations-section-assessment-questions-1',
          )
        ,
          "class-name": 'tw-text-[20px]'
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(BaseSearchbox, {
              class: _normalizeClass([
              'tw-relative tw-h-[44px] tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#ffffff] tw-pt-[10px] tw-pb-[8px] tw-px-[15px] tw-w-[450px]',
            ]),
              "model-value": search.value,
              placeholder: _unref(getComponentUiText)('app-table-search-prompt-text-1'),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (search.value = $event))
            }, null, 8, ["model-value", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", { onClick: handleShowBulkAction }, [
              _createVNode(ButtonBulkActions, {
                "id-popover": 'popover-btn-bulk-action-assessment',
                active: selectedQuestionsChild.value.length >= 1,
                "is-margin-right": false,
                "show-more-actions": isShowMoreActions.value,
                "selected-number": 
                selectedQuestionsChild.value.length > 0
                  ? selectedQuestionsChild.value.length
                  : ''
              ,
                "show-acction-click": true
              }, {
                default: _withCtx(() => [
                  _createVNode(CustomDropDownItem, {
                    style: 'normal',
                    "id-text": 'app-component-assessments-question-bulk-action-item-reset-answers-1',
                    "id-item": `vendor-assess-external-input-reset-answers`,
                    onClick: showModalResetAnswers
                  })
                ]),
                _: 1
              }, 8, ["active", "show-more-actions", "selected-number"])
            ]),
            _createElementVNode("div", null, [
              _createVNode(ButtonFilter, {
                active: false,
                "id-popover": 'popover-btn-filter-assessment',
                "is-margin-right": false
              })
            ]),
            _createElementVNode("div", {
              id: "chr-vendor-display-settings popover-target-1",
              "data-cy": "vendor-display-settings",
              class: _normalizeClass(["toggle-switch-view tw-relative tw-px-[14px] tw-py-[10px]", isCheckToggleOptionSetting.value ? 'setting-option-selected' : '']),
              onClick: openDisplayOption,
              onMouseover: _cache[3] || (_cache[3] = ($event: any) => (isCogHover.value = true)),
              onMouseout: _cache[4] || (_cache[4] = ($event: any) => (isCogHover.value = false))
            }, [
              _createElementVNode("label", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  (isCheckToggleOptionSetting.value)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                    : (!isShowToolTip.value && !isCogHover.value)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                      : (_openBlock(), _createElementBlock("img", _hoisted_10))
                ])
              ])
            ], 34)
          ])
        ])
      ]),
      (!isLoadingRequestedInput.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listQuestion.value, (item, idxHeading) => {
              return (_openBlock(), _createBlock(VendorAssessmentQuestionsDetail, {
                key: item?.itemMasterId,
                "idx-heading": idxHeading + 1,
                "assessment-question": item,
                "selected-questions": selectedQuestions.value,
                "compliance-type-values": complianceTypeValues.value,
                "data-vendor": dataVendor.value,
                "onUpdate:selectedQuestions": handleSelectedQuestions
              }, null, 8, ["idx-heading", "assessment-question", "selected-questions", "compliance-type-values", "data-vendor"]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(AssessmentQuestionSubCategorySkeleton, {
            key: 1,
            "custom-class": "!tw-max-w-[100%]"
          })),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(VendorAssessmentNote, {
          id: "vendor-assess-external-input-questions-notes",
          note: dataVendor.value?.notesResponse ?? '',
          "is-loading": isLoadingRequestedInput.value,
          disable: !isCheckStatusInprogAndWait.value,
          "onUpdate:blur": _cache[5] || (_cache[5] = ($event) => handlePutNoteResponse($event))
        }, null, 8, ["note", "is-loading", "disable"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_14, _toDisplayString(currentPage.value) + "/" + _toDisplayString(totalPages.value) + " " + _toDisplayString(_unref(getComponentUiText)("app-component-assessments-questions-answered-1")), 1)
        ]),
        _createElementVNode("button", {
          id: "vender-view-assessment-btn",
          "data-cy": "vender-submit-assessment-btn",
          class: _normalizeClass(`tw-flex tw-items-center tw-bg-[#387DFF] tw-rounded-[100px] tw-px-[20px] tw-py-[8px] !tw-h-[39px] submit-button ${
          !isCheckStatusInprogAndWait.value ? 'disabled' : ''
        }`),
          disabled: !isCheckStatusInprogAndWait.value,
          onClick: _cache[6] || (_cache[6] = () => handleSubmit())
        }, [
          (!isLoadingAPI.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                ref_key: "innerTextSubmitBtnRef",
                ref: innerTextSubmitBtnRef,
                class: "tw-text-[15px] tw-font-[500] tw-font-[Poppins] tw-leading-[100%] tw-text-white"
              }, _toDisplayString(_unref(getComponentUiText)("app-assessments-vendor-questions-btn-submit-1")), 513))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                style: _normalizeStyle({ width: animationWidth.value + 'px' }),
                class: "tw-flex tw-justify-center tw-h-[39px] tw-w-[39px] tw-text-[#FFF]"
              }, [
                _createVNode(_unref(LottieAnimation), {
                  ref: "anim",
                  "animation-data": _unref(ProgressAnimation),
                  "auto-play": true,
                  loop: true
                }, null, 8, ["animation-data"])
              ], 4))
        ], 10, _hoisted_15)
      ])
    ]),
    _createVNode(_component_b_popover, {
      ref_key: "popover_option",
      ref: popover_option,
      target: "chr-vendor-display-settings popover-target-1",
      placement: "bottom-end",
      click: "true",
      offset: 20,
      "custom-class": `custom-actions-popover assessment-display-options`,
      class: "tw-absolute",
      onShow: _cache[7] || (_cache[7] = ($event: any) => (isShowToolTip.value = true)),
      onHidden: _cache[8] || (_cache[8] = ($event: any) => (isShowToolTip.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(AssessmentDisplayOptions, {
          "list-option": listOption.value,
          class: _normalizeClass('!tw-w-[240px]')
        }, null, 8, ["list-option"])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})